import { render, staticRenderFns } from "./ErrorPopUp.vue?vue&type=template&id=12d3e4ae&scoped=true&"
var script = {}
import style0 from "./ErrorPopUp.vue?vue&type=style&index=0&id=12d3e4ae&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d3e4ae",
  null
  
)

export default component.exports